(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('itemElement', itemElementFactory);

    itemElementFactory.$inject = [];
    function itemElementFactory() {
        return function itemElement(dataItem) {
            var nodes = dataItem && dataItem.$$clone || [];
            for (var node = nodes[0], endNode = nodes[nodes.length - 1]; node && node != endNode.nextSibling; node = node.nextSibling) 
                if (node.nodeType === 1) 
                    return angular.element(node);
            return angular.element();
        }
    }
})();